import moment from "moment";
import { IntlShape } from "react-intl";
import { isNumber, isSomething } from "./langUtils";
import { locale } from "./browserUtils";

export function formatDate(
  timestamp: $TSFixMe,
  intl: $TSFixMe,
  options = null,
) {
  // some month options: 'long', 'short', '2-digit'
  const defaultOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  const mergedOptions = defaultOptions;

  if (options) {
    Object.keys(options)
      .filter((key) => key in defaultOptions)
      .forEach((key) => {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        mergedOptions[key] = options[key];
      });
  }
  return `${intl.formatDate(timestamp, mergedOptions)}`;
}

export function parseISO8601Date(date: $TSFixMe) {
  // IE can not use Date.parse for 2017-08-10T06:59:49.000+0000
  // this is why we should use moment
  // @ts-expect-error TS(2551) FIXME: Property 'documentMode' does not exist on type 'Do... Remove this comment to see the full error message
  if (date !== null && date !== undefined && window.document.documentMode) {
    const m = moment(date, moment.ISO_8601);
    return m.toDate().getTime();
  }
  return Date.parse(date);
}

export function formatTimeIntl(
  timestamp: $TSFixMe,
  intl: $TSFixMe,
  options = null,
) {
  // method name might be strange> reason: formatTime is already defined in langUtils

  const defaultOptions = {
    hour: "2-digit",
    minute: "2-digit",
  };

  const mergedOptions = defaultOptions;

  if (options) {
    Object.keys(options)
      .filter((key) => key in defaultOptions)
      .forEach((key) => {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        mergedOptions[key] = options[key];
      });
  }

  let time = intl.formatDate(timestamp, mergedOptions);

  if (time.split(":")[0].length === 1) {
    time = `0${time}`;
  }
  return time;
}

export function formatDateTime(
  timestamp: $TSFixMe,
  intl: $TSFixMe,
  options: $TSFixMe = null,
  commaSeparated: boolean = false,
) {
  const date = formatDate(timestamp, intl, options);
  const time = formatTimeIntl(timestamp, intl, options);
  return commaSeparated ? `${date}, ${time}` : `${date} ${time}`;
}

// eslint-disable-next-line no-shadow
export const getDaysOfWeek = (
  intl: IntlShape,
  weekday: "long" | "short" | "narrow" | undefined = "long",
) => {
  moment.locale(locale());
  if (moment().utcOffset() < 0) {
    return Array.from({ length: 7 }, (v, i) => i).map((day) =>
      intl.formatDate(new Date(2023, 12, day), { weekday }),
    );
  }
  return Array.from({ length: 7 }, (v, i) => i).map((day) =>
    intl.formatDate(new Date(Date.UTC(2023, 12, day)), { weekday }),
  );
};

export function formatDateTypes(dateString: $TSFixMe, intl: $TSFixMe) {
  const isValidDateFormat = moment(dateString, "YYYY-MM-DD", true).isValid();
  if (isValidDateFormat) {
    return formatDate(dateString, intl);
  }
  const isValidMonYrFormat = moment(dateString, "YYYY-MM", true).isValid();
  if (isValidMonYrFormat) {
    const yearMonOptions = {
      month: "2-digit",
      year: "numeric",
    };
    return `${intl.formatDate(dateString, yearMonOptions)}`;
  }
  const isValidYrFormat = moment(dateString, "YYYY", true).isValid();
  if (isValidYrFormat) {
    const yearrOption = {
      year: "numeric",
    };
    return `${intl.formatDate(dateString, yearrOption)}`;
  }
  return undefined;
}

export function dateDifferenceInDays(dateFrom: $TSFixMe, dateTo: $TSFixMe) {
  const startDate = moment.utc(dateFrom).startOf("day");
  const endDate = moment.utc(dateTo).startOf("day");
  return endDate.diff(startDate, "days");
}

export function daysLeftUntil(date: $TSFixMe) {
  return dateDifferenceInDays(moment(), date);
}

export function convertMomentToISOString(momentDate: $TSFixMe) {
  return momentDate.toISOString();
}

export function subtractMinutesFromDate(
  date: $TSFixMe,
  durationInMinutes: $TSFixMe,
) {
  return moment.utc(date).subtract(durationInMinutes, "minutes").toDate();
}

export function addMinutesFromDate(
  date: $TSFixMe,
  durationInMinutes: $TSFixMe,
) {
  return moment.utc(date).add(durationInMinutes, "minutes").toDate();
}

export function subtractDateStrings(
  startDateString: $TSFixMe,
  endDateString: $TSFixMe,
) {
  if (
    moment(startDateString).isValid() &&
    isSomething(startDateString) &&
    moment(endDateString).isValid() &&
    isSomething(endDateString)
  ) {
    const startDate = moment(startDateString);
    const endDate = moment(endDateString);
    // @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
    return endDate - startDate;
  }
  return undefined;
}

export function addTimeToDateString(
  dateString: $TSFixMe,
  timeInMilliSeconds: $TSFixMe,
) {
  if (moment(dateString).isValid() && isNumber(timeInMilliSeconds)) {
    const updatedDate = moment(dateString).add(
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.... Remove this comment to see the full error message
      timeInMilliSeconds,
      "milliseconds",
    );
    return convertMomentToISOString(updatedDate);
  }
  return undefined;
}
